import {v4 as uuidv4} from "uuid";
import {faker} from "@faker-js/faker";
import { createEnvironment } from "./environments";
import {
  getDepartmentName,
} from "../helpers/get-accounts";

import defaultValues from "../scenarios/edu-scenarios";

const addData = async (data, orgId, deptId, app) => {
  let name = "Default " + faker.lorem.word();
  let _orgId = uuidv4();
  let _deptId = uuidv4();
  let _deptName = data && deptId ? await getDepartmentName(deptId) : "Default";
  let _RoleName =
    data &&
    data.Permissions &&
    data.Permissions.length &&
    data.Permissions[0].PolicyName
      ? data.Permissions[0].PolicyName
      : "ELSCloudformationRole";
  if (data) {
    name = data.Name;
    _orgId = orgId;
    _deptId = deptId;
  }
  let _user =
    localStorage.getItem("username") === null
      ? ""
      : localStorage.getItem("username");

  let item = {
    Name: app ? app.Name : name,
    OrganizationId: _orgId,
    DepartmentId: _deptId,
    DepartmentName: _deptName,
    ID: app ? app.ID : "001",
    CreatedOn: new Date(),
    ModifiedOn: new Date(),
    ParentOrganizationId: "",
    ModifiedBy: null,
    CreatedBy: _user,
    CustomerId: uuidv4(),
    EnvironmentId: app
      ? app.EnvironmentId
      : "30d5a8c6-fe5a-4393-b35c-563a2442aa42",
    EnvironmentName: app
      ? app.EnvironmentName
      : data
      ? data.EnvName.charAt(0).toUpperCase() + data.EnvName.slice(1)
      : "",
    Cost: app ? app.Cost : null,
    Currency: app ? app.Currency : null,
    Status: "ACTIVE",
    Dimension: (data && data.Dimension) || (app && app.Dimension) || "",
    Role: _RoleName,
    PermissionCFNURL: "Default",
    AlertCount: faker.number.int(4, 12),
  };
  if (app) {
    item["Environments"] = [createEnvironment(null, null, null, null, app)];
  } else {
    item["Environments"] = [
      createEnvironment(data, orgId, deptId, item.ID, {
        EnvironmentName: item.EnvironmentName,
        EnvironmentId: item.EnvironmentId,
      }),
    ];
  }
  return item;
};

export const createApplication = async (data, orgId, deptId, app) => {
  const appData = await addData(data, orgId, deptId, app);
  return appData;
};

export const allApplications = () => {
  return defaultValues().allApplications;
};



export const getAppAlerts = () => {
  return [
    {
      type: "security",
      title: "MFA on Root Account",
      body: ` Checks the root account and warns if multi-factor authentication (MFA) is not enabled. 
          For increased security, we recommend that you protect your account by using MFA, 
          which requires a user to enter a unique authentication code from their MFA hardware or virtual device 
          when interacting with the AWS console and associated websites.`,
      catagory: "high",
      alertCriteria: "Red: MFA is not enabled on the root account. ",
      actions: "Log in to your root account and activate an MFA device.",
      additionalInfo:
        "Using Multi-Factor Authentication (MFA) Devices with AWS. MFA is not enabled on the root account.",
    },
    {
      type: "security",
      title: "Security Groups - Specific Ports Unrestricted",
      body: `Checks security groups for rules that allow unrestricted access (0.0.0.0/0) to specific ports. Unrestricted access increases opportunities for malicious activity (hacking, denial-of-service attacks, loss of data). The ports with highest risk are flagged red, and those with less risk are flagged yellow. Ports flagged green are typically used by applications that require unrestricted access, such as HTTP and SMTP. 
          If you have intentionally configured your security groups in this manner, we recommend using additional security measures to secure your infrastructure (such as IP tables)`,
      catagory: "medium",
      alertCriteria: "Yellow: Access to any other port is unrestricted.",
      actions:
        "Restrict access to only those IP addresses that require it. To restrict access to a specific IP address, set the suffix to /32 (for example, 192.0.2.10/32). Be sure to delete overly permissive rules after creating rules that are more restrictive",
      additionalInfo:
        "2 of 2 security group rules allow unrestricted access to a specific port.",
    },
    {
      type: "security",
      title: "Amazon EBS Public Snapshots",
      body: " Checks the permission settings for your Amazon Elastic Block Store (Amazon EBS) volume snapshots and alerts you if any snapshots are marked as public. When you make a snapshot public, you give all AWS accounts and users access to all the data on the snapshot. If you want to share a snapshot with particular users or accounts, mark the snapshot as private, and then specify the user or accounts you want to share the snapshot data with. Note: Results for this check are automatically refreshed several times daily, and refresh requests are not allowed. It might take a few hours for changes to appear.",
      catagory: "low",
      alertCriteria: "Red: The EBS volume snapshot is marked as public.",
      actions:
        "Unless you are certain you want to share all the data in the snapshot with all AWS accounts and users, modify the permissions: mark the snapshot as private, and then specify the accounts that you want to give permissions to. For more information, see Sharing an Amazon EBS Snapshot. Note: For temporary technical reasons, items in this check cannot be excluded from view in the Trusted Advisor console.",
      additionalInfo: "0 EBS snapshots are marked as public.",
    },
    {
      type: "security",
      title: "IAM Use",
      body: " Checks for your use of AWS Identity and Access Management (IAM). You can use IAM to create users, groups, and roles in AWS, and you can use permissions to control access to AWS resources.",
      catagory: "low",
      alertCriteria:
        "Yellow: No IAM users have been created for this account. ",
      actions:
        "Create one or more IAM users and groups in your account. You can then create additional users whose permissions are limited to perform specific tasks in your AWS environment.",
      additionalInfo:
        "At least one IAM user has been created for this account.",
    },
  ];
};
